/**
 * Hand-authored custom icons for glyphs that have no acceptable equivalent in the
 * free icon set. Each is registered under the `fas` prefix with the same iconName
 * the app already references, so no component call sites change.
 *
 * Icon tuple format: [width, height, aliases, unicode, svgPathData]
 */

export const faSwords = {
    prefix: 'fas',
    iconName: 'swords',
    icon: [
        512,
        512,
        [],
        null,
        'M64 96 L96 64 L448 416 L416 448 Z M416 64 L448 96 L96 448 L64 416 Z M58 432 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M410 432 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z',
    ],
}

export const faViolin = {
    prefix: 'fas',
    iconName: 'violin',
    icon: [
        512,
        512,
        [],
        null,
        'M240 56 L272 56 L272 192 L240 192 Z M234 48 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M256 168 C312 168 344 224 344 288 C344 368 304 456 256 456 C208 456 168 368 168 288 C168 224 200 168 256 168 Z',
    ],
}

export const faUserGroupCrown = {
    prefix: 'fas',
    iconName: 'user-group-crown',
    icon: [
        512,
        512,
        [],
        null,
        'M170 200 L156 140 L192 172 L216 132 L240 172 L276 140 L262 200 Z M158 250 a58 58 0 1 0 116 0 a58 58 0 1 0 -116 0 z M112 460 C112 388 156 336 216 336 C276 336 320 388 320 460 Z M326 272 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0 z M300 460 C300 404 332 360 372 360 C420 360 452 404 452 460 Z',
    ],
}

export const faChartScatter = {
    prefix: 'fas',
    iconName: 'chart-scatter',
    icon: [
        512,
        512,
        [],
        null,
        'M64 32 c-13 0 -24 11 -24 24 v336 c0 44 36 80 80 80 h336 c13 0 24 -11 24 -24 s-11 -24 -24 -24 H120 c-18 0 -32 -14 -32 -32 V56 c0 -13 -11 -24 -24 -24 z M158 300 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M238 210 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M318 268 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M378 140 a22 22 0 1 0 44 0 a22 22 0 1 0 -44 0 z M228 344 a18 18 0 1 0 36 0 a18 18 0 1 0 -36 0 z',
    ],
}

export const faWifiWeak = {
    prefix: 'fas',
    iconName: 'wifi-weak',
    icon: [
        512,
        512,
        [],
        null,
        'M150 294 A150 150 0 0 1 362 294 L334 322 A110 110 0 0 0 178 322 Z M226 400 a30 30 0 1 0 60 0 a30 30 0 1 0 -60 0 z',
    ],
}

export const faWifiFair = {
    prefix: 'fas',
    iconName: 'wifi-fair',
    icon: [
        512,
        512,
        [],
        null,
        'M93 237 A230 230 0 0 1 419 237 L390 266 A190 190 0 0 0 122 266 Z M150 294 A150 150 0 0 1 362 294 L334 322 A110 110 0 0 0 178 322 Z M226 400 a30 30 0 1 0 60 0 a30 30 0 1 0 -60 0 z',
    ],
}
